export const MOBILE_SHEET_HEIGHT =
	"min(92dvh, calc(100dvh - var(--safe-area-inset-top, env(safe-area-inset-top, 0px))))"
export const MOBILE_SHEET_BOTTOM_PADDING =
	"max(12px, var(--safe-area-inset-bottom, env(safe-area-inset-bottom, 0px)))"
